import React from 'react'
import { Link } from 'react-router-dom';
import { Menu, Icon } from 'antd';
import './leftMenu.css'
// import axios from 'axios';
// import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';

const { SubMenu } = Menu;

class SiderLeft extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			defaultPath: '',
			TYPEICO: "profile",
			openKeys: [],
		}
	}
	componentWillUnmount() {
		
	}
 	componentDidMount() {
		let itemPath = this.props.defaultPath
		this.props.getChildPath(itemPath)
		this.setState({
			defaultPath: this.props.defaultPath,
		})
	}
	onOpenChange = menuKeys => {
		const latestOpenKey = menuKeys.find(key => this.state.openKeys.indexOf(key) === -1);
		this.setState({
			openKeys: latestOpenKey ? [latestOpenKey] : [],
		});
	}
	handleClick = e => {
		this.props.getChildPath(e.key)
		// this.setState({
		// 	openKeys: [e.keyPath[1]]
		// })
	};
	getMenuNodes = (menuList) => {
		// 	// 菜单对应的icon
		
		const iconConfig = {
			'/subjectController': "folder-open",
			'/labelController': "paper-clip",
			'/userController': 'user-add',
			"/advertController": "shop",
			"/data": 'fund',
			"/inductionManage": "file-text",
			"/liveController": "video-camera",
			"/shareTemplateController": "qrcode",
			"/channelManagement": 'radius-setting',
			"/user": 'user',
			"/bannerController": "picture",
			"/commentController": "security-scan",
			"/konwledge": "read",
			"/datum": "profile",
			"/paycourse": "transaction",
			"/activityxetback": "file-image",
			"/activityController": "like",
			"/admin": "appstore",
			"/aboutController": "switcher",
			"/set": 'setting',
			"/sys/*": "user-add"
		}
		if (menuList) {
			return menuList.map(item => {
				return (
					<SubMenu
						key={item.id}
						title={
							<span>
								<Icon type={iconConfig[item.url] ? iconConfig[item.url] : "profile"} />
								<span>{item.title}</span>
							</span>
						}
					>
						{item.children.map(value => {
							return (<Menu.Item key={value.url}>
								<Link to={value.url}>
									{/* <Icon type={iconConfig[value.url] ? iconConfig[value.url] : "profile"} /> */}
									<span>{value.title}</span>
								</Link>
							</Menu.Item>)
						})}
					</SubMenu>
				)
			})
		}
	}


	render() {
		return (
			<Menu
				onClick={(e) => { this.handleClick(e) }}
				defaultSelectedKeys={[this.props.defaultPath]}
				mode="inline"
				openKeys={this.state.openKeys}
				onOpenChange={this.onOpenChange}
				style={{ width: 200 }}
			>
				{this.getMenuNodes(this.props.menuListRole)}
				{/* <Menu.Item key="/SeekLessons">
					<Link to='/SeekLessons'>
					<Icon type="read" />
						<span>用户求课</span>
					</Link>
				</Menu.Item> */}
			</Menu>
		);
	}
}

export default SiderLeft;